import course from "./course";
import coursePlayer from "./coursePlayer";
import coursePoylvPlayer from "./coursePoylvPlayer";
// import coursePoylvUpload from "./coursePoylvUpload";
import commentDialog from "./commentDialog";
import courseCard from "./courseCard";
import courseCardTwo from "./courseCardTwo";
export default [coursePlayer, commentDialog, course, coursePoylvPlayer, courseCard, courseCardTwo];
